<template>
  <div class="prices">
    <div class="price-title">
      {{ $t("design.priceList.title") || "价目表" }}
      <span class="price-tip">{{
        $t("design.priceList.priceTip") || "（不含税价格）"
      }}</span>
    </div>
    <div class="container" ref="containerRef">
      <xl-scrollbar>
        <div v-if="productPriceList?.length" class="price-container">
          <div
            class="price-main"
            v-for="(i, index) in productPriceList"
            :key="index"
            :ref="(el) => (priceListRef[index] = el)"
          >
            <div class="service-price">
              <!-- <div class="table-title">
              <div class="title-text type-box">
                {{ 'Implant' }}
              </div>
              <div class="title-text">
                {{ '单位' }}
              </div>
              <div class="title-text">
                {{ "单价&交付周期" }}
              </div>
              <div class="title-text">
                {{ "加急单价&加急交付周期" }}
              </div>
            </div> -->
              <div class="table">
                <xl-table
                  :data="i.products"
                  :row-style="{ height: '46px' }"
                  :header-cell-style="headerCellStyle"
                  :cell-style="tableCellStyle"
                >
                  <xl-table-column
                    prop="productConfig"
                    label="product"
                    minWidth="180"
                    maxWidth="330"
                    :resizable="false"
                  >
                    <template #header>
                      <div class="title-text type-box" :class="`type-box-${index}`">
                        {{ i.typeName }}
                      </div>
                    </template>
                    <template #default="{ row }">
                      <div>{{ row?.productConfig || "-" }}<img v-if="row?.aiProduct" class="ai-icon" :src="aiIcon" alt=""></div>
                    </template>
                  </xl-table-column>

                  <xl-table-column
                    prop="chargeUnit"
                    label="chargeUnit"
                    minWidth="80"
                    :resizable="false"
                  >
                    <template #header>
                      <div class="title-text">
                        {{ $t('design.case.unit') || "单位" }}
                      </div>
                    </template>
                    <template #default="{ row }">
                      <div>{{ unitMap[row.chargeUnit] }}</div>
                    </template>
                  </xl-table-column>

                  <xl-table-column
                    prop="price"
                    label="unitPrice"
                    minWidth="270"
                    :resizable="false"
                  >
                    <template #header>
                      <div class="title-text price-table-title">
                        {{ $t('design.price.regularExpenses') || "常规费用及交付周期" }}
                      </div>
                    </template>
                    <template #default="{ row }">
                      <div class="price-day price-text discount-width">
                        <span v-if="row?.discountPrice" class="discount-box">{{ $t('design.price.discount') || '折扣价'}}</span>
                        <span v-if="row?.discountPrice">{{ formatPrice(row.price) + " " + row.currency }}{{ '/' + showPoints(row?.points) }}</span>
                        <span v-else>{{ row.price ? formatPrice(row.price) + " " + row.currency : "-" }}{{ '/' + showPoints(row?.points) }}
                        </span>
                      </div>
                      <div class="price-day day-text">
                        {{
                          row.deliveryDay
                            ? $timeUnit(
                                VueCookieNext.getCookie("lang"),
                                row.deliveryUnit,
                                row.deliveryDay
                              )
                            : "-"
                        }}
                      </div>
                    </template>
                  </xl-table-column>

                  <xl-table-column
                    prop="urgentPrice"
                    label="urgentPrice"
                    minWidth="255"
                    :resizable="false"
                  >
                    <template #header>
                      <div class="urgent-title">
                        <img src="../../assets/image/urgent_price_icon.svg" alt="">
                        <div class="title-text">
                          {{ $t('design.price.urgentExpenses') || "加急费用及交付周期" }}
                        </div>
                      </div>
                    </template>
                    <template #default="{ row }">
                      <div class="price-day price-text">
                        {{
                          row.urgentPrice
                            ? formatPrice(row.urgentPrice) +
                              " " +
                              row.currency
                            : "-"
                        }}{{ '/' + showPoints(row?.urgentPoints) }}
                      </div>
                      <div class="price-day day-text">
                        {{
                          row.urgentDeliveryDay
                            ? $timeUnit(
                                VueCookieNext.getCookie("lang"),
                                row.urgentDeliveryUnit,
                                row.urgentDeliveryDay
                              )
                            : "-"
                        }}
                      </div>
                    </template>
                  </xl-table-column>
                </xl-table>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="node-data-container">
          <noData v-show="!loading"></noData>
        </div>
      </xl-scrollbar>
    </div>
  </div>
</template>

<script setup>
import {
  XlTable,
  XlTableColumn,
  XlScrollbar,
  XlLoading,
} from "@shining3d/ui-components";
import { ref, onMounted, reactive, nextTick, watch } from "vue";
import { useLang } from "@shining3d/common-module/utils/lang.js";
import pricesApi from "../../api/prices";
import noData from "../../components/no-data.vue";
import { VueCookieNext } from "vue-cookie-next";
import { timeMap } from "../../common/enum";
import { formatPrice, $timeUnit, $getCdnUrl } from "../../utils/common";
import _get from 'lodash/get';
import { useStore } from "vuex";
import aiIcon from '../../assets/image/ai_icon.svg';


const $store = useStore();
const { $t } = useLang("@shining3d/xl-design-order");

const institutionId = _get( $store, 'state.factorySelect.id', '');
const loading = ref(true);

const productPriceList = ref([]);
const unitMap = {
  perPiece: $t("design.order.grainUnit") || "颗",
  perJaw: $t("design.order.jawUnit") || "颌",
  perCase: $t("design.order.caseUnit") || "案例",
  perHole: $t('design.order.holeUnit') || '孔'
};
// 背景色
const headerColorMap = {
  '0': 'rgba(85, 135, 255, 0.1)',
  '1': 'rgba(86, 214, 255, 0.1)',
  '2': 'rgba(255, 167, 85, 0.1)',
  '3': 'rgba(255, 116, 85, 0.1)',
};
const showPoints = ( val ) => {
  if( val ) {
    return val + ' ' + $t('design.point.pointNumText')
  } else {
    return '-'
  }
}
const containerRef = ref(null);
const loadingInstance = ref(null);
const waterFall = () => {
  const items = document.querySelectorAll(".price-main");
  const col = 2;
  const gap = 20;
  const colHeight = Array(col).fill(0);
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const minHeight = Math.min(...colHeight);
    const minIndex = colHeight.indexOf(minHeight);
    const left = minIndex
      ? minIndex * item.offsetWidth + gap
      : minIndex * item.offsetWidth;
    const top = minHeight;
    item.style.left = `${left}px`;
    item.style.top = `${top}px`;
    colHeight[minIndex] = colHeight[minIndex] + item.offsetHeight + gap;
  }

  setTimeout(() => {
    loading.value = false;
    loadingInstance.value?.close();
  }, 800);
};
// 改变表格列的背景色
const tableCellStyle = ({ row, column, rowIndex, columnIndex }) => {
    if (columnIndex === 0 ) {
      return {background: '#FAFBFD', 'border-right': '0 !important', 'padding-left': '24px !important'}
    } else if (columnIndex === 1) {
      return {background: '#FAFBFD'}
    }else if (columnIndex === 2) {
      return {background: '#F3F6FF', 'text-align': 'right', 'padding-right': '5vw !important', 'border-left': '2px solid #ffffff;'}
    } else if (columnIndex === 3) {
      return {background: '#FFF7EF', 'text-align': 'right', 'padding-right': '56px !important'}
    }
}
// 表头背景色
const headerCellStyle = ({ rowIndex, columnIndex }) => {
  if( rowIndex === 0){
    if( columnIndex === 0){
      return {background: '#EFF1F7', 'border-right': '0 !important'}
    } else if ( columnIndex === 1 ){
      return {background: '#EFF1F7'}
    }else if (columnIndex === 2) {
      return {background: '#D4E1FF'}
    } else if (columnIndex === 3) {
      return {background: '#FFE9D4'}
    }
  }
}
const getListProductPrice = () => {
  if (loadingInstance.value) {
    loadingInstance.value?.close();
  }
  loadingInstance.value = XlLoading.service({
    target: containerRef.value,
    background: "rgba(255,255,255, 1)",
  });

  pricesApi
    .listProductPrice({ lang: VueCookieNext.getCookie("lang"), orgID: institutionId })
    .then((res) => {
      if (res && res.status === "success") {
        productPriceList.value = (res.result || []).map((item) => ({
          ...item,
          url: $getCdnUrl({ bucket: item.imgBucket, dfsID: item.imgDfsID }),
        }));
      }
      loadingInstance.value?.close();
    });
};
// getListProductPrice();
// 价目表列表
const priceListRef = ref([]);

// watch(()=>priceListRef.value, (val)=>{
//   if( val){
//     setTimeout(() => {
//       nextTick(() => {
//         waterFall();
//       })
//     }, 300);
//   }
// },
// { deep: true, immediate: true }
// )

onMounted(() => {
  getListProductPrice();
});
// onMounted(() => {
//   // setTimeout(() => {
//   //   waterFall();
//   // }, 500);
//   // nextTick(()=> {
//   //   waterFall();
//   // })
//   if(priceListRef.value?.length){
//     waterFall();
//   }
// });
</script>

<style lang="scss" scoped>
.prices {
  font-family: "Alibaba PuHuiTi 2.0";
  height: calc(100% - 32px);
  margin: 16px;
  overflow: hidden;

  .price-title {
    font-size: 18px;
    font-weight: 700;
    line-height: 25.2px;
    margin-bottom: 20px;
    color: #2c364e;

    .price-tip {
      font-size: 14px !important;
      font-weight: 500 !important;
      line-height: 22px !important;
      color: #42526e !important;
    }
  }

  .price-main {
    // position: absolute;
    min-width: 609px;
    // display: inline-block;
    box-sizing: border-box;

    // padding: 13px 16px;
    // margin: 0 0 20px 0;
    // border-radius: 12px;
    // background: #ffffff;
    // border: 2px solid #e0e4ea;
    // &:nth-child(2n) {
    //   margin-right: 0 !important;
    // }
    .service-type {
      width: 100%;
      height: 62px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      padding-bottom: 14px;
      margin-bottom: 14px;
      border-bottom: 1px solid #a5acbe;

      .type-left {
        display: flex;

        .type-img {
          width: 65.34px;
          height: 47.92px;
          margin-right: 4px;
        }

        .type-text-box {
          height: 46px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .service-text {
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            color: #737e99;
          }

          .type-text {
            font-size: 18px;
            font-weight: 700;
            line-height: 26px;
            color: #42526e;
          }
        }
      }

      .type-right {
        font-family: "DingTalk JinBuTi";
        font-size: 48.84px;
        font-style: italic;
        font-weight: 700;
        line-height: 47px;
        color: #edf3ff;
      }
    }

    .service-price {
      .type-box {
        width: 164px;
        height: 46px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px 0px 12px 0px;
        background: linear-gradient(90deg, #5587FF 0%, #6D98FF 100%);
        // background: url(../../assets/image/color1_icon.png);
        z-index: 2;
        font-size: 18px !important;
        font-weight: 700 !important;
        color: #FFFFFF !important;
      }
      // .type-box-0 {
      //   background: url(../../assets/image/color1_icon.png) !important;
      // }
      // .type-box-1 {
      //   background: url(../../assets/image/color2_icon.png) !important;
      // }
      // .type-box-2 {
      //   background: url(../../assets/image/color3_icon.png) !important;
      // }
      // .type-box-3 {
      //   background: url(../../assets/image/color4_icon.png) !important;
      // }
      .table-title {
        height: 46px;
        display: flex;
        align-items: center;
        border-radius: 12px 0px 0px 0px;
        background: #edf3ff;
        justify-content: space-between;
        margin-bottom: 16px;
        padding-right: 98px;
        box-sizing: border-box;
      }
      .price-day {
        display: inline-block;
      }
      .day-text{
        // padding-left: 60px;
        width: 6vw;
        min-width: 85px;
      }
      .price-text{
        min-width: 150px;
      }
      .discount-width{
        min-width: 175px;
        // display: inline-flex;
        // align-items: center;
      }
      .title-text {
        font-size: 16px;
        font-weight: 500;
        color: #2c364e;
      }
      .price-table-title{
        // margin-left: 16px;
        text-align: right;
        padding-right: 5vw;
      }
      // .table {
      //   margin-bottom: 16px;
      // }
      .discount-box{
        display: inline-block;
        height: 18px;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        padding: 0 6px;
        border-radius: 2px;
        // margin-bottom: 4px;
        margin-right: 4px;
        background: linear-gradient(90deg, #FF6914 17.42%, #FFCF54 97.98%);
        // background: url(../../assets/image/discount_icon.png) !important;
        color: #FFFFFF;
        background-size: 100% 100% !important;
        background-repeat: no-repeat !important;
      }
    }
  }

  :deep(.el-scrollbar__wrap) {
    height: calc(100% - 48px);
  }

  :deep(.xl-table.el-table.el-table--border .el-table__cell) {
    font-family: "Alibaba PuHuiTi 2.0";
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    color: #42526e;
  }

  .price-container {
    // width: 1228px;
    // position: relative;
    // height: 100%;
    margin: 0 auto;
    padding: 16px;
    box-sizing: border-box;
    border-radius: 12px;
    border: 1px solid #e0e4ea;
    background: #ffffff;
    min-width: 1180px;
    // column-count: 2; /* 列数 */
    // -moz-column-count: 2; /* Firefox */
    // -webkit-column-count: 2; /* Safari and Chrome */
    // column-gap: 20px; /* 列间距 */
  }

  .loading-container {
    opacity: 0;
  }

  :deep(.el-scrollbar__view) {
    height: 100%;
  }

  .node-data-container {
    height: 100%;
  }

  :deep(.el-table .cell) {
    padding: 0 !important;
  }
  :deep(.el-table){
    --el-table-border: 2px solid #ffffff;
    box-sizing: border-box;
  }
  :deep(.xl-table.el-table.el-table--border .el-table__cell){
    border-right: 2px solid #ffffff;
  }
  :deep(.el-table--border .el-table__cell:first-child .cell) {
    word-break: keep-all !important;
  }
  .container {
    height: 100%;
    width: 100%;
  }
  :deep(.el-table .el-table__cell){
    padding: 0 !important;
  }
  :deep(.el-table__header-wrapper){
    border-radius: 12px 0 0 0;
  }
  .urgent-title{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 56px;
    img{
      margin-left: 16px;
      margin-right: 6px;
    }
  }
  .ai-icon{
    margin-left: 4px;
  }
}
</style>
